// Polyfill Fixes
Object.assign = require('object-assign')

if (!Object.entries) {
    Object.entries = function( obj ){
        var ownProps = Object.keys( obj ),
            i = ownProps.length,
            resArray = new Array(i); // preallocate the Array
        while (i--)
            resArray[i] = [ownProps[i], obj[ownProps[i]]];

        return resArray;
    };
}
///

require('../../shared/js/pusher-channels');

window.APR_DATE_FORMAT = 'MMM D, YYYY';
window.APR_DATE_FORMAT2 = 'ddd, MMM D';

window._ = require('lodash');
window.Cookies = require('js-cookie');

import Echo from "laravel-echo"

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: window.apr.pusher_key,
    cluster: window.apr.pusher_cluster,
    encrypted: true
});

window.googleMapsConfig = {
    key: window.apr.google_api_key,
    v: window.apr.google_api_version,
    libraries: 'places,geometry',
    channel: 'web',
    language: 'en'
}

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.moment = require('moment-timezone');
window.money = require('accounting');

window.$ = window.jQuery = require('jquery');
import tether from 'tether';
window.Tether = tether;
require('bootstrap');
require('parsleyjs');
require('parsleyjs/src/extra/validator/words');

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

window.Vue = require('vue');
require('vue-resource');

/**
 * We'll register a HTTP interceptor to attach the "CSRF" header to each of
 * the outgoing requests issued by this application. The CSRF middleware
 * included with Laravel will automatically verify the header's value.
 */

Vue.http.interceptors.push((request, next) => {
    request.headers.set('X-CSRF-TOKEN', Laravel.csrfToken);

    next();
});

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from "laravel-echo"

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });
